// this contains named variables for the base tints and hues used in the other colour files.
// NOTE: These colours should never be used outside of fe-brary.
// Use colours from colour-scheme or color-atom-palette instead
// TODO use colors from import { pricefinderLight }
// from '@domain-group/design-tokens'; instead
// these are being used for the time being so existing components on the old tokens still work
export default (function () {
  return {
    colour: {
      priceFinderNavy400: '#22365a',
      priceFinderNavy500: '#0b2047',
      priceFinderNavy600: '#071939',
      priceFinderGreen25: '#f3faf2',
      priceFinderGreen50: '#e6f6e5',
      priceFinderGreen100: '#b6e4b2',
      priceFinderGreen200: '#86d37f',
      priceFinderGreen300: '#56c24c',
      priceFinderGreen400: '#26b019',
      priceFinderGreen500: '#0ea800',
      priceFinderGreen600: '#0c9700',
      priceFinderGreen700: '#0b8600',
      priceFinderGreen800: '#086400',
      priceFinderLobster100: '#ffcec3',
      priceFinderLobster500: '#ff613d',
      priceFinderLobster600: '#f74a23',
      priceFinderCanary500: '#fc0',
      priceFinderCanary100: '#ffefaf',
      priceFinderTurquoise500: '#05bbb6',
      priceFinderTurquoise100: '#ccf1f0',
      priceFinderGrimace500: '#612b87',
      priceFinderBlurple500: '#514aea'
    }
  };
});